export default "__VITE_ASSET__5C4rV4lC__"